import { TextField, Tooltip } from '@mui/material';
import HelpTwoToneIcon from '@mui/icons-material/HelpTwoTone';

export const Search = ({ searchQuery, setSearchQuery, searchBy = "" }) => {
    return (
        <TextField
            variant="outlined"
            placeholder="Search by..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            fullWidth
            InputProps={{
                endAdornment: (
                    <Tooltip title={searchBy} arrow placement="top">
                        <HelpTwoToneIcon fontSize='small' sx={{ color: '#707b7c' }}/>
                    </Tooltip>
                )
            }}
            sx={{
                width: '25%', 
                mb: 2,
                backgroundColor: '#f9f9f9',
                borderRadius: '5px',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: '#d1d1d1',
                },
                '&:hover fieldset': {
                    borderColor: '#0073e6', 
                },
                '&.Mui-focused fieldset': {
                    borderColor: '#0056b3', 
                },
                },
                '& .MuiInputBase-input': {
                fontSize: '0.9rem', 
                padding: '8px 12px',
                },
            }}     
        />
    )
}